import type Q from 'q';

import type { ActionContext } from 'js/lib/ActionContext';

import loadCourseMaterialsUtil from 'bundles/course-v2/utils/loadCourseMaterials';

export const loadCourseMaterials = (
  actionContext: ActionContext,
  {
    courseSlug,
    refetchLearnerGoals,
    refetch,
  }: { refetchLearnerGoals?: () => Promise<any>; courseSlug: string; refetch: boolean }
): Q.Promise<any> => loadCourseMaterialsUtil(actionContext, courseSlug, refetch, refetchLearnerGoals);
